// prozess-schiene — ersetzt Marianns Prozess-SVG.
//
// In ihren Vorlagen ist der Ablauf eines Modells als SVG gezeichnet: vier bis
// fuenf Kaesten mit Pfeilen dazwischen, feste Breite 820 Pixel. Auf dem Telefon
// wird das entweder winzig oder abgeschnitten, und eine Aenderung an einem Wort
// bedeutet neu zeichnen.
//
// Als gebauter Baustein loest sich beides: der Ablauf bricht auf schmalen
// Bildschirmen von selbst in eine senkrechte Liste um, und die Schritte sind
// Text. Das Muster stammt aus der Chronik-Schiene des 420Pharma-Projekts.
//
// Nummeriert wird per CSS-Zaehler und nicht im Text — sonst muesste beim
// Einschieben eines Schritts alles darunter von Hand umnummeriert werden.
//
// Einstellungen am Wrapper:
//   data-titel         Ueberschrift
//   data-ausrichtung   "waagerecht" (Standard) | "senkrecht".
//                      Waagerecht bricht unter 640 px selbst auf senkrecht um.
//   data-nummerieren   "true" (Standard) | "false"
import { el, leerHinweis, lesSchalter } from '@lib/bausteine/dom';
import { zerlegeZeilen } from '@lib/bausteine/zerlege';
import { zeichneAus } from '@lib/bausteine/auszeichnung';

export function prozessSchiene(wurzel: HTMLElement, quelle: string): Node {
  const stationen = zerlegeZeilen(quelle);

  if (stationen.length === 0) {
    return leerHinweis('Noch keine Schritte. Format: Titel | Kurzbeschreibung');
  }

  const titel = (wurzel.getAttribute('data-titel') ?? '').trim();
  const waagerecht =
    (wurzel.getAttribute('data-ausrichtung') ?? '').trim().toLowerCase() !== 'senkrecht';
  const nummerieren = lesSchalter(wurzel, 'data-nummerieren', true);

  return el(
    'section',
    { class: 'eoe-reset eoe-schiene' },
    titel && el('h3', { class: 'eoe-titel' }, titel),
    el(
      'ol',
      {
        class: [
          'eoe-schiene__liste',
          waagerecht ? 'eoe-schiene__liste--waagerecht' : 'eoe-schiene__liste--senkrecht',
          nummerieren ? 'eoe-schiene__liste--nummeriert' : '',
        ]
          .filter(Boolean)
          .join(' '),
      },
      ...stationen.map((station) => {
        const [name, text] = station.felder;
        return el(
          'li',
          { class: 'eoe-schiene__schritt' },
          el('span', { class: 'eoe-schiene__marke', 'aria-hidden': 'true' }),
          el(
            'div',
            { class: 'eoe-schiene__inhalt' },
            el('p', { class: 'eoe-schiene__name' }, zeichneAus(name ?? '')),
            text && el('p', { class: 'eoe-schiene__text' }, zeichneAus(text)),
          ),
        );
      }),
    ),
  );
}
